var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNorifOff(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M15.273 17.87S15.273 21 12 21s-3.273-3.13-3.273-3.13M18.5 3 5 21m.455-9.391C5.455 7.696 6.273 3 12 3s6.546 4.696 6.546 8.609c0 3.913 2.454 6.26 2.454 6.26H3s2.455-2.347 2.455-6.26Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNorifOff);
export default __webpack_public_path__ + "static/media/norif_off.75664df54209d42c248dab194f11d650.svg";
export { ForwardRef as ReactComponent };